import { StringDevtoolsDock } from "../../modules/dev-tools/core/StringDevtoolsDock";
import { StringDevtoolDefinition } from "../../models/devtools/StringDevtool";

export class DevtoolsManager {
  private definitions: Map<string, StringDevtoolDefinition> = new Map();
  private dock: StringDevtoolsDock | null = null;

  register(definition: StringDevtoolDefinition | null): void {
    if (!definition || this.definitions.has(definition.id)) {
      return;
    }

    this.definitions.set(definition.id, definition);
    if (!this.dock) {
      this.dock = new StringDevtoolsDock();
    }
    this.dock.add(definition);
  }

  setFPS(fps: number): void {
    this.dock?.setFPS(fps);
  }

  destroy(): void {
    this.definitions.clear();
    this.dock?.destroy();
    this.dock = null;
  }
}
